import React from "react";
import PropTypes from "prop-types";

import ViewBrochures from "../../PatientMaterial/ViewBrochures";
import StyledPatientMaterials from "../../PatientMaterial/StyledPatientMaterials";

const SelectTIF = ({
  registerPatient,
  handleCheckboxChange,
  showErrors,
  brochures,
  treatmentFormText,
}) => {
  const styles = {
    title: "text-3xl font-bold text-neutral-700 my-4",
    divider: "border-t border-[#768692] bg-[#768692]",
    container: "min-h-125 space-y-4",
    list: "space-y-2 pl-6 mt-4",
    listItem: "text-base font-normal text-neutral-800",
    listItemWithPadding: "pt-3 text-base font-normal text-neutral-800",
    brochureWrapper: "mt-5",
    brochureGrid: "grid grid-cols-1 gap-6 md:grid-cols-3",
    confirmSection: "mt-3",
    checkboxLabel:
      "flex items-start gap-3 cursor-pointer select-none text-base leading-5 text-[#646464]",
    checkbox:
      "mt-0.5 h-5 w-5 shrink-0 cursor-pointer rounded border border-[#00567a] accent-[#00567a] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#00567a]/30",
    checkboxError: "border-[#e41818] accent-[#e41818]",
    checkboxTextError: "text-[#e41818]",
    errorMessage: "mt-2 font-light text-[#e41818]",
  };

  const checkboxClass =
    showErrors && !registerPatient.confirmation_other1
      ? `${styles.checkbox} ${styles.checkboxError}`
      : styles.checkbox;

  return (
    <React.Fragment>
      <div data-testid="patient-initiation-select-tif">
        <h1 className={styles.title} data-testid="patient-initiation-tif-title">
          Please select the {treatmentFormText?.treatment_form_text_short} for
          patient category
        </h1>

        <hr
          className={styles.divider}
          data-testid="patient-initiation-tif-divider"
        />

        <div
          className={styles.container}
          data-testid="patient-initiation-tif-content"
        >
          <ol className={styles.list} data-testid="patient-initiation-tif-instructions">
            <li
              className={styles.listItem}
              data-testid="patient-initiation-tif-instruction-1"
            >
              1. Select the {treatmentFormText?.treatment_form_text} that you would
              like to complete.
            </li>
            <li
              className={styles.listItemWithPadding}
              data-testid="patient-initiation-tif-instruction-2"
            >
              2. Print the selected form and input all of the required information
              before confirming that the {treatmentFormText?.treatment_form_text}{" "}
              has been completed via the checkbox and clicking 'Next' at the
              bottom of the page.
            </li>
            <li
              className={styles.listItemWithPadding}
              data-testid="patient-initiation-tif-instruction-3"
            >
              3. After clicking 'Next', you can generate a Prescription Authorisation
              Form. The PAF will be sent to the pharmacy nominated by the patient.
            </li>
          </ol>
          <StyledPatientMaterials>
            <div
              className={styles.brochureWrapper}
              data-testid="patient-initiation-tif-brochures"
            >
              <div className={styles.brochureGrid}>
                {brochures.map((brochure, index) => (
                  <div
                    key={index}
                    data-testid={`patient-initiation-tif-brochure-${brochure?.id ?? index}`}
                  >
                    <ViewBrochures item={brochure} index={index} />
                  </div>
                ))}
              </div>
            </div>
          </StyledPatientMaterials>

          <div
            className={styles.confirmSection}
            data-testid="patient-initiation-tif-confirm-section"
          >
            <label
              htmlFor="confirmation_other1"
              className={styles.checkboxLabel}
              data-testid="patient-initiation-tif-confirmation-label"
            >
              <input
                type="checkbox"
                id="confirmation_other1"
                name="confirmation_other1"
                className={checkboxClass}
                checked={registerPatient.confirmation_other1 || false}
                onChange={handleCheckboxChange}
                data-testid="patient-initiation-tif-confirmation-checkbox"
              />
              <span
                className={
                  !registerPatient.confirmation_other1 && showErrors
                    ? styles.checkboxTextError
                    : ""
                }
                data-testid="patient-initiation-tif-confirmation-text"
              >
                I confirm that the{" "}
                {treatmentFormText?.treatment_form_text.toLowerCase()} has been
                completed and signed for this patient*
              </span>
            </label>
          </div>
          {showErrors && (
            <div
              className={styles.errorMessage}
              data-testid="patient-initiation-tif-error"
            >
              <p>Required</p>
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

SelectTIF.propTypes = {
  registerPatient: PropTypes.object,
  handleCheckboxChange: PropTypes.func,
  showErrors: PropTypes.bool,
  brochures: PropTypes.array,
  treatmentFormText: PropTypes.object,
};

export default SelectTIF;
